import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "react-bootstrap";
import React, { useState } from "react";
import { Modal, DatePicker, Select, Space, message, Radio } from "antd";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
const { RangePicker } = DatePicker;


const formatDate = (timestamp) => {
  if (!timestamp) return "";

  const date = new Date(timestamp);

  const pad = (n) => (n < 10 ? "0" + n : n);

  return (
    pad(date.getDate()) +
    "/" +
    pad(date.getMonth() + 1) +
    "/" +
    date.getFullYear() +
    " " +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds())
  );
};

const mapTransactions = (data) => {
  return data.map((t) => ({
    Business: t.developerAccountName,
    Marchand: t.merchantAccountName,
    Montant: t.amount,
    "Montant réel": t.realAmount,
    "Mode de paiement": t.paymentMethodName,
    "Numéro de client": t.clientNumber,
    Statut: t.status,
    "Référence de transaction": t.transactionReference,
    "Date de paiement": formatDate(t.createdAt),
  }));
};

const ExportTransaction = ({ transactions }) => {

    const [open, setOpen] = useState(false);
    const [dateRange, setDateRange] = useState(null);
    const [status, setStatus] = useState(null);
    const [format, setFormat] = useState("excel");
    const [loading, setLoading] = useState(false);

    // 🔥 FILTRAGE LOCAL
    const applyFilters = () => {
        let filtered = [...transactions];

        // 📅 filtre date (createdAt en timestamp)
        if (dateRange && dateRange[0] && dateRange[1]) {
        const start = dateRange[0].startOf("day").valueOf();
        const end = dateRange[1].endOf("day").valueOf();

        filtered = filtered.filter((t) => {
            return t.createdAt >= start && t.createdAt <= end;
        });
        }

        // 📌 filtre statut
        if (status) {
        filtered = filtered.filter((t) => t.status === status);
        }

        return filtered;
    };

    const handleExport = async () => {
        try {
        setLoading(true);

        const data = applyFilters();
    
        if (!data.length) {
            message.warning("Aucune transaction trouvée avec ces filtres");
            return;
        }

        if (format === "excel") {
            exportExcel(data);
        } else {
            // exportPDF(data);
        }

        message.success("Export réussi !");
        setOpen(false);
        } catch (err) {
        console.error(err);
        message.error("Erreur export");
        } finally {
        setLoading(false);
        }
    };

    const exportExcel = (data) => {
        const formattedData = mapTransactions(data);
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();

        worksheet["!cols"] = [
            { wch: 20 }, // Business
            { wch: 20 }, // Marchand
            { wch: 12 }, // Montant
            { wch: 15 }, // Montant réel
            { wch: 20 }, // Mode de paiement
            { wch: 20 }, // Numéro de client
            { wch: 12 }, // Statut
            { wch: 35 }, // Référence de transaction
            { wch: 22 }, // Date de paiement
        ];

        XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");

        const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
        });

        const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
        });

        saveAs(blob, `transactions_${Date.now()}.xlsx`);
    };

//   const exportPDF = (data) => {
//     const formattedData = mapTransactions(data);
//     const doc = new jsPDF();

//     const tableColumn = Object.keys(formattedData[0] || {});
//     const tableRows = formattedData.map((row) => Object.values(row));

//     doc.text("Rapport", 14, 15);

//     doc.autoTable({
//       head: [tableColumn],
//       body: tableRows,
//       startY: 20,
//     });

//     doc.save(`rapport_${Date.now()}.pdf`);
//   };


    return (
        <>
            <Button disabled={transactions && transactions.length === 0} className="filtrer" onClick={() => setOpen(true)} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <DownloadOutlined />
                Exporter
            </Button>
            <Modal
                title="Exporter les transactions"
                open={open}
                onCancel={() => setOpen(false)}
                onOk={handleExport}
                confirmLoading={loading}
                okText="Télécharger"
            >
                <Space direction="vertical" style={{ width: "100%" }} size="middle">

                {/* DATE RANGE */}
                <div>
                    <label>Date</label>
                    <RangePicker
                    style={{ width: "100%" }}
                    onChange={(v) => setDateRange(v)}
                    />
                </div>

                {/* STATUS */}
                <div>
                    <label>Status</label>
                    <Select
                    style={{ width: "100%" }}
                    placeholder="Tous les statuts"
                    allowClear
                    onChange={(v) => setStatus(v)}
                    options={[
                        { value: "SUCCESS", label: "SUCCESS" },
                        { value: "FAILED", label: "FAILED" },
                        { value: "PENDING", label: "PENDING" },
                        { value: "REJECTED", label: "REJECTED" },
                    ]}
                    />
                </div>

                {/* FORMAT */}
                <div>
                    <label>Format</label>
                    <Radio.Group
                    value={format}
                    onChange={(e) => setFormat(e.target.value)}
                    >
                    <Radio value="excel">Excel</Radio>
                    <Radio disabled value="pdf">PDF</Radio>
                    </Radio.Group>
                </div>

                </Space>
            </Modal>
        </>
    )
}

export default ExportTransaction;